import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function CoachInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user, loadTeams, setActiveTeam } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/coach-invites/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/coach-invites/${token}/accept`);
      await loadTeams(); setActiveTeam(data.team_id);
      toast.success(`You're now a coach on ${info.team_name}`);
      nav(`/teams/${data.team_id}/playbook`);
    } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto card p-6 sm:p-8 tpc-rise" data-testid="coach-invite-page">
      <UserPlus size={32} className="text-[#FF8A1F]" />
      <h1 className="h1 mt-3">Coach invite</h1>
      {err ? (
        <><p className="text-red-300 mt-3" role="alert" data-testid="coach-invite-error">{err}</p><Link to="/" className="btn btn-ghost mt-5" data-testid="coach-invite-home">Go to dashboard</Link></>
      ) : !info ? <p className="text-slate-400 mt-3">Checking invite…</p> : (
        <>
          <p className="text-slate-300 mt-3" data-testid="coach-invite-info"><b>{info.head_coach}</b> invited you to help coach <b>{info.team_name}</b>. You'll be able to create and edit plays in its playbook.</p>
          <p className="text-xs text-slate-500 mt-2">Signed in as {user?.email}</p>
          {info.already_member ? (
            <Link to="/teams" className="btn btn-primary w-full mt-6" data-testid="coach-invite-already">You're already on this team</Link>
          ) : (
            <button className="btn btn-primary w-full mt-6 text-base" onClick={accept} disabled={busy} data-testid="coach-invite-accept-btn">{busy ? "Joining…" : "Accept & join team"}</button>
          )}
        </>
      )}
    </div>
  );
}
